import { useSetAtom } from 'jotai';
import { AxiosResponse } from 'axios';
import { useState, useEffect } from 'react';

import localStorageUtil from 'src/utils/localStorageUtil';
import { getTenantRedirectUri } from 'src/utils/multi-tenant-uri';
import standardConstants from 'src/utils/constants/standardConstants';
import { saveStandardBasicCampusToStorage } from 'src/utils/standard-storage-util';

import store from 'src/store';
import brandApi from 'src/api/brandApi';
import serviceTypeApi from 'src/api/serviceTypeApi';

import { StandardBasicCampus } from 'src/types/standard-basic-campus';

const useStandardLogin = () => {
  const [standardBasicCampus, setStandardBasicCampus] = useState<StandardBasicCampus | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [isReady, setIsReady] = useState(false);
  const setStandardAtom = useSetAtom(store.standard.useStandardAtom);

  const getServiceType = async () => {
    const serviceCode = getTenantRedirectUri();
    const response = await serviceTypeApi.getServiceType(serviceCode);
    return response.data;
  };

  const fetchStandardBasicCampusData = async () => {
    /*
         1. Standard의 기본 캠퍼스 데이터를 가져오는 함수 실행
         2. 테스트 필요한 부분
         - 자동로그인, 통합로그인
         - 로그아웃
    */

    const brandCode = localStorageUtil.getBrandCode() ?? '';
    let response: AxiosResponse<any> | null = null;
    if (brandCode) response = await brandApi.brandInfo(brandCode);
    else response = await brandApi.getStandardBasicCampus();

    // task-0220: brandInfo falsy/handled → Promise.resolve(null)
    if (!response) return null;
    return response.data.data[0];
  };

  useEffect(() => {
    const fetchStandardBasicCampus = async () => {
      const {
        data: { serviceType },
      } = await getServiceType();

      if (serviceType.value === standardConstants.ENTERPRISE) {
        setStandardAtom(standardConstants.ENTERPRISE);
        setIsReady(true);
        return;
      }

      try {
        setStandardAtom(standardConstants.STANDARD as 'STANDARD');
        setIsLoading(true);
        const data = await fetchStandardBasicCampusData();
        setStandardBasicCampus(data);

        // 로컬 스토리지에 Standard Basic Campus 데이터 저장
        if (data) saveStandardBasicCampusToStorage(data);
        setIsReady(true);
      } finally {
        setIsLoading(false);
      }
    };

    fetchStandardBasicCampus();
  }, [setStandardAtom]);

  return {
    getStandardBasicCampus: fetchStandardBasicCampusData,
    standardBasicCampus,
    isLoading,
    isReady,
  };
};

export default useStandardLogin;
